import { iDialogMessagesFile, Message } from "../omnichannel/use-omnichannel";
import { useFetch2 } from "../util";

export interface ITransferOmniChannelDialog {
  dialogId: number;
  workspaceId: number;
  userId?: number;
  transferType: "USER" | "SEQUENTIAL" | "WORKSPACE";
  transferToThirdPartySystem: boolean;
}
export interface IUserInfo {
  id: number | null;
  name: string | null;
  createdAt: string;
  phone: string | null;
  email: string | null;
  workspaceId: number | null;
  avatarUrl: string | null;
}
const OmnichannelService = () => {
  const request = useFetch2();

  const findDialogHistoryData = async (
    dialogId: number
  ): Promise<iDialogMessagesFile> => {
    return request(`/api/omnichannel/dialogs/${dialogId}/history/data`, {
      method: "GET"
    });
  };

  const findDialogHistoryMessages = async (
    dialogId: number,
    data: {
      limit: number;
      cursorMessageId: number;
      cursorDialogId: number;
      direction?: "older" | "newer";
    }
  ): Promise<Message[]> => {
    const params = new URLSearchParams();

    params.append("limit", String(data.limit));
    params.append("cursorMessageId", String(data.cursorMessageId));
    params.append("cursorDialogId", String(data.cursorDialogId));
    params.append("direction", data.direction ?? "older");

    return request(
      `/api/omnichannel/dialogs/${dialogId}/history/messages?${params}`,
      {
        method: "GET"
      }
    );
  };

  const transferOminichannelDialog = async (
    data: ITransferOmniChannelDialog
  ): Promise<{ ok: true }> => {
    return request(
      `/api/omnichannel/dialogs/transfer`,
      { method: "POST" },
      data
    );
  };
  const getContact = async (dialogId: number): Promise<IUserInfo> => {
    return request(`/api/omnichannel/dialogs/${dialogId}/contact`, {
      method: "GET"
    });
  };
  const joinDialog = async (dialogId: number): Promise<IUserInfo> => {
    return request(`/api/omnichannel/dialogs/${dialogId}/join`, {
      method: "POST"
    });
  };
  const joinQueueDialog = async (dialogId: number): Promise<IUserInfo> => {
    return request(`/api/omnichannel/queue/dialogs/${dialogId}/join`, {
      method: "POST"
    });
  };
  const openDialog = async (dialogId: number): Promise<IUserInfo> => {
    return request(`/api/omnichannel/dialogs/${dialogId}/open`, {
      method: "POST"
    });
  };

  const deleteMessages = async (dialogId: number) => {
    return request(`/api/omnichannel/dialogs/message/${dialogId}`, {
      method: "DELETE"
    });
  };

  return {
    findDialogHistoryData,
    findDialogHistoryMessages,
    transferOminichannelDialog,
    getContact,
    joinDialog,
    joinQueueDialog,
    openDialog,
    deleteMessages
  };
};

export default OmnichannelService;
